import { render } from "./OrderTypes.vue?vue&type=template&id=1ce67b64&ts=true"
import script from "./OrderTypes.vue?vue&type=script&lang=ts"
export * from "./OrderTypes.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__